
<ul class="parameter-navigation">
    <li
        (click)="slider.slideToName('upgrade');"
        class="selected"
        [class.selected]="slider.selectedName === 'upgrade'"
        test-id="upgrade.bac-net.parameter-window.tab.upgrade"
        i18n="@@upgrade.bac-net-window.tab.upgrade.title"
    >Upgrade</li>
    <li
        (click)="slider.slideToName('application-set')"
        [class.selected]="slider.selectedName === 'application-set'"
        test-id="upgrade.bac-net.parameter-window.tab.application-set"
        i18n="@@upgrade.bac-net-window.tab.application-set.title"
    >Application Set</li>
</ul>
<clx-slide-area #slider style="height: 100px">
    <clx-slide name="upgrade">
        <clx-data-grid
            #upgradeGrid
            id="upgrad-bacnet-parameter-grid"
            test-id="upgrade.bac-net.parameter-window.grid.upgrade"
            [showSearchPanel]="false"
            [showGroupPanel]="false"
            [showColumnChooser]="false"
            [columnAutoWidth]="false"
            [showPager]="false"
            [data]="upgradeData"
            [selection]="{ mode : 'single' }"
            (onRowClick)="selectEntry($event)"
        >
            <clx-grid-column
                caption="Modified"
                dataField="modifyDate"
                dataType="date"
                [format]="localisation.getDateTimeFormat()"
                test-id="upgrade.bac-net.parameter-window.grid.upgrade.column-modified"
                i18n-caption="@@upgrade.bac-net-window.grid.upgrade.modified"
            ></clx-grid-column>
            <clx-grid-column
                caption="Name"
                dataField="FileName"
                dataType="string"
                test-id="upgrade.bac-net.parameter-window.grid.upgrade.column-filename"
                i18n-caption="@@upgrade.bac-net-window.grid.upgrade.name"
            ></clx-grid-column>
            <clx-grid-column
                caption="Version"
                dataField="Version"
                dataType="string"
                test-id="upgrade.bac-net.parameter-window.grid.upgrade.column-version"
                i18n-caption="@@upgrade.bac-net-window.grid.upgrade.version"
            ></clx-grid-column>
            <clx-grid-column
                caption="Description"
                dataField="Description"
                dataType="string"
                test-id="upgrade.bac-net.parameter-window.grid.upgrade.column-description"
                i18n-caption="@@upgrade.bac-net-window.grid.upgrade.description"
            ></clx-grid-column>
        </clx-data-grid>
    </clx-slide>
    <clx-slide name="application-set">
        <clx-data-grid
            #applicationSetGrid
            id="upgrad-bacnet-applicationset-grid"
            test-id="upgrade.bac-net.parameter-window.grid.application-set"
            [showSearchPanel]="false"
            [showGroupPanel]="false"
            [showColumnChooser]="false"
            [columnAutoWidth]="false"
            [showPager]="false"
            [data]="applicationSetData"
            [selection]="{ mode : 'single' }"
            (onRowClick)="selectEntry($event)"
        >
            <clx-grid-column
                caption="Modified"
                dataField="createDate"
                dataType="date"
                [format]="localisation.getDateTimeFormat()" 
                test-id="upgrade.bac-net.parameter-window.grid.application-set.column-modified"
                i18n-caption="@@upgrade.bac-net-window.grid.application-set.modified"
            ></clx-grid-column>
            <clx-grid-column
                caption="Name"
                dataField="fileName"
                dataType="string"
                test-id="upgrade.bac-net.parameter-window.grid.application-set.column-filename"
                i18n-caption="@@upgrade.bac-net-window.grid.application-set.name"
            ></clx-grid-column>
            <clx-grid-column
                caption="Version"
                dataField="version"
                dataType="string"
                test-id="upgrade.bac-net.parameter-window.grid.application-set.column-version"
                i18n-caption="@@upgrade.bac-net-window.grid.application-set.version"
            ></clx-grid-column>
            <clx-grid-column
                caption="Description"
                dataField="description"
                dataType="string"
                test-id="upgrade.bac-net.parameter-window.grid.column-description"
                i18n-caption="@@upgrade.bac-net-window.grid.application-set.description"
            ></clx-grid-column>
        </clx-data-grid>
    </clx-slide>
</clx-slide-area>